export enum TableType {
  CONFIGURATIONS = 'CONFIGURATIONS',
  EMAIL_TEMPLATES = 'EMAIL_TEMPLATES',
  SMS_TEMPLATES = 'SMS_TEMPLATES',
  MS_PLAN_CARRIERS = 'MS_PLAN_CARRIERS',
  MNS_PLAN_CARRIERS = 'MNS_PLAN_CARRIERS',
  LEAD_MANAGEMENT = 'LEAD_MANAGEMENT',
  ENROLLMENT_MANAGEMENT = 'ENROLLMENT_MANAGEMENT',
  PRODUCER_MANAGEMENT = 'PRODUCER_MANAGEMENT'
}
